'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = Modal;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Modal($rootScope, $uibModal) {
  'ngInject';

  function openModal() {
    var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var modalClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'modal-default';

    var modalScope = $rootScope.$new();

    _angular2.default.extend(modalScope, scope);

    return $uibModal.open({
      template: require('./modal.html'),
      windowClass: modalClass,
      scope: modalScope
    });
  }

  return {
    editStudent: function editStudent(student) {
      $uibModal.open({
        template: require('./edit-student/edit-student.html'),
        controller: 'StudentController',
        controllerAs: 'admin',
        windowClass: 'student-modal',
        resolve: {
          data: function data() {
            return student;
          }
        }
      });
    },
    editTutor: function editTutor(tutor) {
      $uibModal.open({
        template: require('./edit-tutor/edit-tutor.html'),
        controller: 'TutorController',
        controllerAs: 'admin',
        windowClass: 'student-modal',
        resolve: {
          data: function data() {
            return tutor;
          }
        }
      });
    },

    confirm: {
      delete: function _delete() {
        var del = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _angular2.default.noop;

        return function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var slicedArgs = Reflect.apply(Array.prototype.slice, args);
          var name = slicedArgs.shift();
          var deleteModal;

          deleteModal = openModal({
            modal: {
              dismissable: true,
              title: 'Confirm Delete',
              html: '<p>Are you sure you want to delete <strong>' + name + '</strong> ?</p>',
              buttons: [{
                classes: 'btn-danger',
                text: 'Delete',
                click: function click(e) {
                  deleteModal.close(e);
                }
              }, {
                classes: 'btn-default',
                text: 'Cancel',
                click: function click(e) {
                  deleteModal.dismiss(e);
                }
              }]
            }
          }, 'modal-danger');

          deleteModal.result.then(function (event) {
            Reflect.apply(del, event, slicedArgs);
          });
        };
      }
    }
  };
}

exports.default = _angular2.default.module('calApp.Modal', []).factory('Modal', Modal).name;


// WEBPACK FOOTER //
// ./client/components/modal/modal.service.js